import Button from "@components/Button";
import { Row } from "@components/Layout";
import { DropdownMenu } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const UserRowWrapper = styled(Row)`
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;
export const DropdownArrow = styled(DropdownMenu.Icon)`
  transition: all 0.2s;
  &:is([data-expanded]) {
    rotate: 180deg;
  }
`;

export const DropdownButton = styled(Button)`
  height: 40px;
  font-size: 16px;
  user-select: none;
  pointer-events: none;
`;
